import './about.css';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PDF_Icon from '../Media/Images/pdf.png';
import GoogleDocs_Icon from '../Media/Images/googleDocs.png';

function About() {
	const navigate = useNavigate();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<>
			<div className='about-container'>
				<div className='about-left-box'>
					<h1 className='about-left-title'>
						{/* Hi! */}
						<span id='letterHi' className='easeInOut'>
							H
						</span>
						<span id='letterhI' className='easeInOut'>
							i
						</span>
						<span id='letterComma' className='easeInOut'>
							!
						</span>
						<br />
						{/* I'm */}
						<span id='letterIm' className='easeInOut'>
							I
						</span>
						<span id='letterApos' className='easeInOut'>
							'
						</span>
						<span id='letteriM' className='easeInOut'>
							m
						</span>
						&nbsp;
						{/* Travis */}
						<span id='letterTravis' className='easeInOut'>
							T
						</span>
						<span id='lettertRavis' className='easeInOut'>
							r
						</span>
						<span id='lettertrAvis' className='easeInOut'>
							a
						</span>
						<span id='lettertraVis' className='easeInOut'>
							v
						</span>
						<span id='lettertravIs' className='easeInOut'>
							i
						</span>
						<span id='lettertraviS' className='easeInOut'>
							s
						</span>
						<span id='lettertravisComma' className='easeInOut'>
							,
						</span>
						<br />
						{/* Data Scientist */}
						<span id='letterData' className='easeInOut'>
							D
						</span>
						<span id='letterdAta' className='easeInOut'>
							a
						</span>
						<span id='letterdaTa' className='easeInOut'>
							t
						</span>
						<span id='letterdatA' className='easeInOut'>
							a
						</span>
						&nbsp;
						<span id='letterScientist' className='easeInOut'>
							S
						</span>
						<span id='lettersCientist' className='easeInOut'>
							c
						</span>
						<span id='letterscIentist' className='easeInOut'>
							i
						</span>
						<span id='lettersciEntist' className='easeInOut'>
							e
						</span>
						<span id='letterscieNtist' className='easeInOut'>
							n
						</span>
						<span id='letterscienTist' className='easeInOut'>
							t
						</span>
						<span id='letterscientIst' className='easeInOut'>
							i
						</span>
						<span id='letterscientiSt' className='easeInOut'>
							s
						</span>
						<span id='letterscientisT' className='easeInOut'>
							t
						</span>
						<br />
						{/* & IT Professional */}
						<span id='letterAmp' className='easeInOut'>
							&
						</span>
						&nbsp;
						<span id='letterIT' className='easeInOut'>
							I
						</span>
						<span id='letteriT' className='easeInOut'>
							T
						</span>
						&nbsp;
						<span id='letterProfessional' className='easeInOut'>
							P
						</span>
						<span id='letterpRofessional' className='easeInOut'>
							r
						</span>
						<span id='letterprOfessional' className='easeInOut'>
							o
						</span>
						<span id='letterproFessional' className='easeInOut'>
							f
						</span>
						<span id='letterprofEssional' className='easeInOut'>
							e
						</span>
						<span id='letterprofeSsional' className='easeInOut'>
							s
						</span>
						<span id='letterprofesSional' className='easeInOut'>
							s
						</span>
						<span id='letterprofessIonal' className='easeInOut'>
							i
						</span>
						<span id='letterprofessiOnal' className='easeInOut'>
							o
						</span>
						<span id='letterprofessioNal' className='easeInOut'>
							n
						</span>
						<span id='letterprofessionAl' className='easeInOut'>
							a
						</span>
						<span id='letterprofessionaL' className='easeInOut'>
							l
						</span>
					</h1>
					<p className='about-left-description'>
						Strong Technical Communication Skills
					</p>
					<div className='about-left-button-box'>
						<button
							onClick={() => navigate('/contact')}
							className='about-contact-button'>
							Contact me!
						</button>
						<div className='about-resume-box'>
							<h2 className='about-resume-title'>My Resume:</h2>
							<div className='about-resume-buttons-wrapper'>
								<a href='Travis_Lamberte_Resume.pdf' download>
									<img src={PDF_Icon} alt='PDF' className='about-resume-pdf' />
								</a>
								<a
									href='https://docs.google.com/document/d/1cYpPYM66l6z3Jp8V999oICjoJAMXVm3qzjc2r2kIJ_Y/edit?usp=sharing'
									target='_blank'
									rel='noreferrer'>
									<img
										src={GoogleDocs_Icon}
										alt='Google Docs'
										className='about-resume-googleDocs'
									/>
								</a>
							</div>
						</div>
					</div>
				</div>
				<div className='about-right-box'>
					<div className='about-right-title'>About</div>
					<p className='about-right-description'>
						Hi! I’m Travis — a Data Scientist and IT Professional with strong
						programming fundamentals and a deep understanding of how systems
						actually work. My background in IT gives me a unique perspective on
						building reliable, scalable, and maintainable data solutions.
						<br />
						<br />
						I’m driven by learning: new tools, deeper theory, and better ways to
						solve real problems. Whether I’m working on analytics, data
						engineering, or automation, I enjoy tackling{' '}
						<span onClick={() => navigate('/projects')}>projects</span>
						&nbsp; that push me to grow and refine my technical skill set.
						<br />
						<br />I stay active in the Seattle tech community and enjoy
						connecting with others who are passionate about data,
						infrastructure, and problem‑solving. Let’s connect and start a
						conversation.
					</p>
				</div>
			</div>
		</>
	);
}

export default About;
